import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "button"]
  static values = { checked: Boolean }

  connect() {
    this.updateUI()
  }

  toggle() {
    this.checkedValue = !this.checkedValue
    this.updateUI()

    if (this.hasCheckboxTarget) {
      this.checkboxTarget.checked = this.checkedValue
      this.checkboxTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  get switchButton() {
    if (this.hasButtonTarget) return this.buttonTarget
    if (this.element.matches("button[role='switch']")) return this.element
    return this.element.querySelector("button[role='switch']")
  }

  updateUI() {
    const btn = this.switchButton
    if (!btn) return

    btn.setAttribute("aria-checked", this.checkedValue)

    if (this.checkedValue) {
      btn.classList.remove("bg-gray-200")
      btn.classList.add("bg-blue-600")
      btn.querySelector("span").classList.remove("translate-x-0")
      btn.querySelector("span").classList.add("translate-x-5")
    } else {
      btn.classList.remove("bg-blue-600")
      btn.classList.add("bg-gray-200")
      btn.querySelector("span").classList.remove("translate-x-5")
      btn.querySelector("span").classList.add("translate-x-0")
    }
  }
}
